import React, { useState, useEffect } from 'react';
import { convertiDataComputer2Umano } from './funzioni.js'
import Clessidra from '../Pagine/Clessidra'
import stile from './stile.module.css';
import Cerchio_ok from './cerchio_ok.png';
import Cerchio_no from './cerchio_no.png';

import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';

function PayPalButton(props) {    
    const [errorMessage, setErrorMessage] = useState('');
    const [flagPagamentoCompletato, setFlagPagamentoCompletato] = useState(false);
    const [flagPagamentoFallito, setFlagPagamentoFallito] = useState(false);
  
    const createOrder = async () => {
      try {
        const response = await fetch(props.UrlBackend, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            op: 'paypalOrderCarrello',
            emak: props.emak,
            sessionId:props.sessionId
          }),
        });
  
        const orderData = await response.json();
  
        if (orderData) {
          if (orderData.id) {
            return orderData.id;
          } else {
            const errorDetail = orderData?.details?.[0];
            const errorMessage = errorDetail
              ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
              : JSON.stringify(orderData);
    
            throw new Error(errorMessage);
          }
        } else {
          // Gestisci il caso in cui 'id' non è presente nell'oggetto o orderData è null
          throw new Error("orderData not found or invalid data");
        }
  
      } catch (error) {
        console.error(error);
        //setErrorMessage(`Could not initiate PayPal Checkout...<br><br>${error}`);
        setErrorMessage("Impossibile procedere al checkout Paypal");
        props.setFlagPagamentoFallito(true);
      }
    };
  
    const onApprove = async (data, actions) => {      
      try {
        const response = await fetch(props.UrlBackend, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            op: 'paypalCaptureCarrello',
            emak: props.emak,
            sessionId:props.sessionId,
            orderID: data.orderID
          }),
        });
  
        const orderData = await response.json();
  
        const errorDetail = orderData?.details?.[0];
  
        if (errorDetail?.issue === 'INSTRUMENT_DECLINED') {
          return actions.restart();
        } else if (errorDetail) {
          throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
        } else if (!orderData.purchase_units) {
          throw new Error(JSON.stringify(orderData));
        } else {
          const transaction =
            orderData?.purchase_units?.[0]?.payments?.captures?.[0] ||
            orderData?.purchase_units?.[0]?.payments?.authorizations?.[0];
          setErrorMessage(
            `Transazione ${transaction.status}: ${transaction.id}`,
          );
          if (transaction.status == "COMPLETED") {
            setFlagPagamentoCompletato(true);
            props.setPaypalTransactionId(transaction.id); // pare essere vuota, non arriva dal backend? Per ora non serve
          } else {
            setFlagPagamentoFallito(true);
          }
          console.log(
            'Capture result',
            orderData,
            JSON.stringify(orderData, null, 2),
          );
          props.setFlagTransazioneConclusa(true);
        }
      } catch (error) {
        console.error(error);
        // setErrorMessage(`Sorry, your transaction could not be processed...<br><br>${error}`);
        setFlagPagamentoFallito(true);
        setErrorMessage("Transazione Paypal FALLITA");
        props.setFlagTransazioneConclusa(true);
      }
    };
    return (
      <div>
        {!flagPagamentoCompletato && errorMessage=="" && <PayPalButtons          
          createOrder={createOrder}
          onApprove={onApprove}
        />}
        {errorMessage!="" && !flagPagamentoCompletato && <div id="result-message" style={{backgroundColor: "#FF0000", color:"#FFFFFF", padding: "4px"}} dangerouslySetInnerHTML={{ __html: errorMessage }} />}
        {flagPagamentoFallito && <div id="result-message" style={{backgroundColor: "#FF0000", color:"#FFFFFF", padding: "4px"}}>Pagamento non effettuato</div>}
        {flagPagamentoCompletato && <div id="result-message" style={{backgroundColor: "#3e9e1eff", color:"#FFFFFF", padding: "4px"}}>Pagamento completato</div>}
      </div>
    );
}

function Carrello(props) {
    const PAGINE = {
        "caricamentoDati": 1,
        "visualizzaCarrello": 2,
        "carrelloImplicito": 3,
        "bottonePagaCarrello": 4
    };
    const [pagina, setPagina] = useState(PAGINE.caricamentoDati);
    const [risultatoServerDatiDovutoQuoteIscritto,setRisultatoServerDatiDovutoQuoteIscritto]=useState([]);
    const [importi, setImporti] = useState([]);
    const [flagTransazioneConclusa, setFlagTransazioneConclusa] = useState(false);
    const [paypalTransactionId, setPaypalTransactionId] = useState("");

    const regexNumeroValido = /^-?\d+([,.]\d{1,2})?$/;

    useEffect(() => {
        ricercaDatiDovutoQuoteIscritto();
    }, [])
    
    // gestione del tasto BACK
    useEffect(() => {
        if (props.flagRichiestaBack) {
            props.setFlagRichiestaBack(false);
            props.callback(props.PAGINECLIENTI.home);
        } 
    }, [props.flagRichiestaBack]) 
    
    useEffect(() => {
        const viste = new Set();
        const oggi = new Date();

        const iniziali = risultatoServerDatiDovutoQuoteIscritto.map(el => {
            const chiave = `${el.IDASSABB}_${el.TIPO_QUOTA}`; // nuova chiave univoca per abbonamento
            const importo = parseFloat(el.IMPORTO).toFixed(2).replace(".", ",");
            const dataRata = new Date(el.DATA_RATA);

            const isPrimaRata = !viste.has(chiave);
            if (isPrimaRata) {
                viste.add(chiave);
            }

            // Se NON è la prima rata ed è futura, azzera IMPORTO
            const importoFinale = (!isPrimaRata && dataRata >= oggi) ? "0,00" : importo;            

            return {
                IDASSABB: el.IDASSABB,
                DESCRIZIONE: el.DESCRIZIONE,
                TIPOQUOTA: el.TIPO_QUOTA,
                DATA_RATA: el.DATA_RATA,
                IMPORTO_INIZIALE: importo,
                IMPORTO: importoFinale,
                VALIDO: true
            };
        });

        setImporti(iniziali);
        if (props.pagaSubito !== undefined) setPagina(PAGINE.carrelloImplicito); else setPagina(PAGINE.visualizzaCarrello);
    }, [risultatoServerDatiDovutoQuoteIscritto]);

    useEffect(() => {
      // bisogna passare per questa pagina intermedia altrimenti va a fare la fetch di aggiornaCarrello
      // prima che sia settata la variabile di stato importi
      if (pagina==PAGINE.carrelloImplicito) aggiornaCarrello();
    }, [pagina])

    const aggiornaImporto = (valore, indice) => {
        const nuovo = [...importi];
        const valido = regexNumeroValido.test(valore.trim());

        nuovo[indice].IMPORTO = valore;
        nuovo[indice].VALIDO = valido;
        setImporti(nuovo);
    };

    function ricercaDatiDovutoQuoteIscritto() {
        setPagina(PAGINE.caricamentoDati);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"debitoQuoteIscritto",emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica (e.incassiabbass.1)");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINECLIENTI.login);
                if(valoreDiRitorno.risultatoOperazione===1){
                    console.log("debitoQuoteIscritto: " + valoreDiRitorno.risultatoRitorno);
                    var componiPersona = valoreDiRitorno.COGNOME+" "+valoreDiRitorno.NOME;
                    if (valoreDiRitorno.NUMERO_TESSERA != "") componiPersona += " ("+valoreDiRitorno.NUMERO_TESSERA+")";
                    //setInsIscrittiEdi(componiPersona);
                    setRisultatoServerDatiDovutoQuoteIscritto(valoreDiRitorno.risultatoRitorno);
                    
                    // spostato nella useEffect, eliminare se non ci sono problemi:
                    // if (props.pagaSubito !== undefined) setPagina(PAGINE.bottonePagaCarrello); else setPagina(PAGINE.visualizzaCarrello);
                } else {
                    props.setPagina(props.PAGINECLIENTI.login);
                }            
            },
            (error) => {props.setPagina(props.PAGINECLIENTI.login)}
            );
    }

    function aggiornaCarrello() {
        setPagina(PAGINE.caricamentoDati);
        var requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ op: "aggiornaCarrello", articoli:importi, emak: props.emak, sessionId: props.sessionId })
        };
        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valore_di_ritorno) => {
                    if (valore_di_ritorno.verifvers === 0) {
                        // necessario aggiornare la app
                        props.callbackAggiornaApp();
                        return;
                    }
                    if (valore_di_ritorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }
                    if (valore_di_ritorno.risultatoOperazione !== 1) { 
                        window.alert("Sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"); 
                        props.callback(props.PAGINECLIENTI.login);
                        return; 
                    }
                    
                    
                    setPagina(PAGINE.bottonePagaCarrello);
                },
                (error) => {
                    props.callback(props.PAGINECLIENTI.login);
                    return;
                }
            );                                 
    }    

    if (pagina === PAGINE.caricamentoDati || pagina == PAGINE.carrelloImplicito) {
        return (<Clessidra loading={true} />)
    }

    if (pagina === PAGINE.visualizzaCarrello || pagina === PAGINE.bottonePagaCarrello) {
        const totale = importi.reduce((somma, riga) => {
            const num = parseFloat((riga.IMPORTO || "0").replace(",", "."));
            return somma + (riga.VALIDO && !isNaN(num) ? num : 0);
        }, 0);

        if (totale==0) {
          return (
            <div style={{ margin: "auto", backgroundColor:"#F0F0F0", padding: 10 }}>
                <div style={{backgroundColor:"#3aa3ffff", padding: "4px", color:"#FFFFFF"}}>
                    Non ci sono pagamenti da effettuare
                </div>
                <div style={{ display: "flex", justifyContent: "center", margin:10 }}>
                  <div className={[stile.baVerdeSoft, stile.baNormale, stile.baFlex, stile.baSecondoBottone].join(" ")} 
                      onClick={() => {
                          props.callback();
                      }}>
                      <div className={stile.spazioIconaPiccola}>
                          <img className={stile.iconaPiccolaQuadrata} src={require('./okbianco.png')} />
                      </div>
                      Continua
                  </div>
              </div>
            </div>
          )
        }

        return (
            <div style={{ margin: "auto", backgroundColor:"#F0F0F0", padding: 10 }}>
                <div style={{backgroundColor:"#3aa3ffff", padding: "4px", color:"#FFFFFF"}}>
                    {pagina === PAGINE.visualizzaCarrello ? "Seleziona pagamenti" : "Seleziona metodo di pagamento"}                    
                </div>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                    {risultatoServerDatiDovutoQuoteIscritto.map((elemento, indice) => (
                        importi!=undefined && importi[indice]!=undefined && importi[indice].IMPORTO_INIZIALE!="0,00" && (pagina === PAGINE.visualizzaCarrello || importi[indice].IMPORTO!="0,00") &&
                        <tr key={indice}>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>
                            {elemento.DESCRIZIONE}
                            <br/>
                            {elemento.DATA_RATA!="" && <><b>pagare entro {convertiDataComputer2Umano(elemento.DATA_RATA)}</b><br/></>}
                            {/* prima che scatti la useEffect che setta importi, importi[indice] è undefined. La useEffect è praticamente immediata
                            quindi l'umano non vede l'attesa, ma il programma arriva qua anche troppo presto, con undefined, quindi serve questo controllo */}
                            dovuto {importi!=undefined ? importi[indice]!=undefined ? importi[indice].IMPORTO_INIZIALE : "...":"..."} €
                        </td>
                        <td style={{ padding: "8px", textAlign: "right", borderBottom: "1px solid #ccc" }}>
                            {importi[indice]?.IMPORTO ?? ""} €
                        </td>
                        {pagina === PAGINE.visualizzaCarrello &&
                            <td style={{ padding: "8px", textAlign: "center", borderBottom: "1px solid #ccc" }}>
                                {importi[indice]?.IMPORTO == importi[indice]?.IMPORTO_INIZIALE ? 
                                    <img src={Cerchio_no} height="20" width="20" alt="non pagata" style={{marginLeft:5}} onClick={() => aggiornaImporto("0,00", indice)}/>
                                :
                                    <img src={Cerchio_ok} height="20" width="20" alt="pagata" onClick={() => aggiornaImporto(importi[indice].IMPORTO_INIZIALE, indice)}/>                                
                                }
                            </td>
                        }
                        </tr>
                    ))}
                    </tbody>
                    <tfoot>
                    <tr>
                        <td style={{ padding: "8px", fontWeight: "bold" }}>Totale acquisti</td>
                        <td style={{ padding: "8px", textAlign: "right", fontWeight: "bold" }}>
                        {totale.toFixed(2).replace(".", ",")} €
                        </td>
                    </tr>
                    </tfoot>
                </table> 
                {totale > 0 && pagina === PAGINE.visualizzaCarrello &&
                    <div style={{display:"flex", flexDirection:"row"}}>
                        <div style={{flex:1}} className={stile.movimentiBottoneScaricaRicevuta} onClick={() => {aggiornaCarrello();}}>Vai al pagamento</div>
                    </div>                          
                } 

                {pagina === PAGINE.bottonePagaCarrello &&                                    
                    <PayPalScriptProvider options={{ 'client-id': 'AaDR0vR9aLP0_c5FqLpBPQz2UwpK4OdNhJ1KQSPzpL0GiD1rYcfQOIEbsvJBJkWfLrSGwCKfeWcsgGHY', 'currency':'USD' }}>
                        <PayPalButton 
                            {...props}
                            setFlagTransazioneConclusa={setFlagTransazioneConclusa} 
                            setPaypalTransactionId={setPaypalTransactionId}
                        />
                    </PayPalScriptProvider>
                }
                
                {flagTransazioneConclusa &&
                    <div style={{ display: "flex", justifyContent: "center", margin:10 }}>
                        <div className={[stile.baVerdeSoft, stile.baNormale, stile.baFlex, stile.baSecondoBottone].join(" ")} 
                            onClick={() => {
                                props.callback();
                            }}>
                            <div className={stile.spazioIconaPiccola}>
                                <img className={stile.iconaPiccolaQuadrata} src={require('./okbianco.png')} />
                            </div>
                            Continua
                        </div>
                    </div>
                }

            </div>
        )
    }

    return (
        <div>Errore pagina non trovata (Carrello)</div>
    )
}

export default Carrello;
